module.exports = __webpack_public_path__ + "img/select-icon5.0816c669.png";